import { createAction } from 'redux-actions';

export const userDocumentsFetch = createAction('USER_DASHBOARD_USER_DOCUMENTS_FETCH');
export const userDocumentsSet = createAction('USER_DASHBOARD_USER_DOCUMENTS_SET');
